import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Container, Button, Modal, Badge } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { FaFile, FaPlus, FaPen, FaTrash } from 'react-icons/fa6';
import { GetText, ReplaceText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../../config/helper';
import DateTimeFormats from '../../config/date-time-format';
import Loading from '../../inc/Loading';
import TagHeaders from '../../inc/Headers';
import '../../config/global';
import ImgLogoGemini from '../../img/logo_gemini_academy.png';
import ImgShareThread from '../../img/pic_share_thread.png';
import DiscussionForm from '../../inc/discussion/Form';
import DiscussionFormReply from '../../inc/discussion/FormReply';
import DiscussionBlockReply from '../../inc/discussion/BlockReply';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;

function listReplyPerPage(content,currpage,perpage) {
  var sPage = (currpage-1)*perpage; 
  var ePage= sPage+perpage;
  return content.slice(sPage, ePage);

}

export default class DiscussionDetailMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: localStorage.getItem('doc_id'),
      memberStatus: localStorage.getItem('status'),
      currentUrl: '',
      activePage: '',
      arrPagePath: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 2,
      id: '',
      title: '',
      categoryid: '', 
      category: '',
      excerpt: '',
      status: '',
      createbyid: '',
      createby: '',
      createon: '',
      lastupdate: '',
      replies_all: [],
      replies_table: [],
      data: {},
      modal_show_thread: false,
      modal_show_reply: false,
      modal_content_thread: {},
      modal_content_reply: {},
      modal_title_thread: '',
      modal_title_reply: '',
      isLoad: false
    }
  }

  handlePageChange = (page) => {
    this.setState({ 
      currentPage: page ,
      replies_table: listReplyPerPage(this.state.replies_all,page,this.state.perPage)
    });
  };

  handleRowsPerPageChange = (newPerPage, page) => {
    this.setState({
      perPage: newPerPage,
      currentPage: page, // Reset/sync page to avoid out-of-bound errors
      replies_table: listReplyPerPage(this.state.replies_all,page,newPerPage)
    });
  };
  handlePopOpen(name, name_title, title, name_content, content) {
    var sendcontent = {};
    sendcontent.data = content;
    sendcontent.currpage = this.state.currentUrl;

    this.setState({ 
      [name]: true,
      [name_title]: title,
      [name_content]: sendcontent
    });
  }
  handlePopClose(name, name_title, name_content) {
    this.setState({ 
      [name]: false,
      [name_title]: '',
      [name_content]: ''
    });
  }
  handleOpenPage(url) {
    window.location.href=url;
  }
  urlpublish(valId,nextstat) {
    return;
  }
  handlePublish(valId,nextstat) {
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this topic?");
    if(stat === true) {
      var datatext ='{"thread_id":"'+valId+'","thread_status":"'+nextstat+'","form_id":"form-publish"}';
      var urlFetch = global.config.urlLink+"/threadedit";
      var data = JSON.parse(datatext);
      fetch(urlFetch, {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }, body : JSON.stringify(data)
      }).then(res => {
          if(res.status === 200)
              return res.json() 
      }).then( resJson => {
          if(resJson.status === '200') {
              window.location.href=global.config.urlHost+this.state.activePage+"/discussion";
          } else {
              console.log('Something happened wrong');
          }
          
      });
    }
  }
  listThReplyContent() {   
    var column = [];
    column.push({ 
      name: "Description", 
      cell: (row) => <DiscussionBlockReply value={{"currpage": this.state.currentUrl, "data": row, "type": "detail" }} /> 
    });

    return column;
    
  }
  componentDidMount() {    
    var url = window.location.href;
    var id = url.substring(url.lastIndexOf('/') + 1);

    var currentURL = window.location.pathname;
    var arrPath = currentURL.split('/');
    var id = arrPath[arrPath.length-1];
    
    fetch(global.config.urlLink+"/threadview/" + id, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }
      }).then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          console.log('Something happened wrong');
        }
      }).then(resultJson => {
        if(resultJson.status === "200") {
          var results = resultJson.values[0];
          var threadData = results.content[0].maincontent;
          threadData.id = results.docid;
          
          var reply_contents = results.scontent.sort((a,b) => b.subcontent.createDate._seconds - a.subcontent.createDate._seconds)
            .filter((list) =>  {
              return (list.subcontent.replyStatus.trim() === global.config.threadStatus[1].trim());
            });
          var reply_contents_slice = reply_contents;
          if(reply_contents.length > 0) {
            reply_contents_slice = listReplyPerPage(reply_contents,this.state.currentPage,this.state.perPage);
          }
          
          this.setState({
            currentUrl: currentURL,
            activePage: arrPath[1],
            arrPagePath: arrPath,
            id: results.docid,
            title: threadData.threadTitle,
            categoryid: threadData.threadCategoryId, 
            category: threadData.threadCategoryName,
            excerpt: ReplaceOutputTextHTML(threadData.threadDescription),
            status: threadData.threadStatus,
            createbyid: threadData.createById,
            createby: threadData.createByName,
            createon: threadData.createDate !== undefined? DateTimeFormats(threadData.createDate._seconds,"datetime-short") : '',
            lastupdate: threadData.lastUpdate !== undefined? DateTimeFormats(threadData.lastUpdate._seconds,"datetime-short") : '',
            replies_all: reply_contents,
            replies_table: reply_contents_slice,
            data: threadData,
            isLoad: true,
            totalRows: reply_contents.length
          }) 
        } 

      })

    
  }

  render() {
    return (
      <div className="detail-discussion-gemini">
        <TagHeaders value={
                        {	
                          docid: '', 
                          title: 'Novaio Academy - Gemini Academy', 
                          description: '',
                          links: global.config.urlHost+this.state.currentUrl
                        }
                      }/>
        <section>
          <Container className='mb-4'>
            <div className='text-center'><img src={ImgLogoGemini} className='logo'/></div>
          </Container>
        </section>
        
        {
          this.state.isLoad === true ? 
              <section>
                <Container>
                  <div className="br-8">
                    {
                        <div>
                          <Badge pill bg="secondary" className="px-2 py-1 mb-2">{this.state.category}</Badge>
                          <h4 className="text-start mb-1">{this.state.title}</h4>
                          <div className="mb-4 text-black-50 d-flex">
                            {this.state.replies_all.length > 0 && <>
                              <span className="me-3">{GetText() ? "• terakhir ditanggapi " : "  last response "} {this.state.createon}</span>
                            </>}
                            <span className="me-3">{GetText() ? "• tanggapan : " : "  response : "} {this.state.replies_all.length}</span>
                            
                          </div>
                        </div>
                    }
                    <div className="row mt-3">
                      <div className="col-md-9">
                        <div className="bg-light mb-3" style={{height:"2px"}}></div>
                        <div className="text-start mb-1">{parse(this.state.excerpt)}</div>
                        <div className="row">
                          <div className="col-4">
                            {this.state.createbyid === this.state.memberId && <>
                              <FaPen className="style-action-icons" aria-label="edit" onClick={this.handlePopOpen.bind(this,"modal_show_thread","modal_title_thread", GetText() ? "Edit Ruang Diskusi" : "Edit Discussion Room", "modal_content_thread", this.state.data)} />  
                              <FaTrash className="style-action-icons" aria-label="delete" onClick={this.handlePublish.bind(this, this.state.id, global.config.threadStatus[2])} />  
                            </>}
                          </div>
                          <div className="col-8 d-flex justify-content-end text-end mb-3">
                            <div className='br-8 p-2 bg-light'>
                            {GetText() ? "dibuat oleh" : "created by"} {this.state.createby} <br/>
                            {GetText() ? "pada" : "on"} {this.state.createon}
                            </div>
                          </div>
                        </div>
                       

                        <div className="bg-light mt-3 mb-3" style={{height:"2px"}}></div>
                        {
                          this.state.replies_all.length > 0 && (
                            <>
                            <h6 >{this.state.replies_all.length} {GetText() ? "Tanggapan" : "Response "} </h6>
                            <div>
                              {
                                this.state.replies_all
                                .map((threadItem, i) => {
                                  threadItem.threadId=this.state.id;
                                  threadItem.threadTitle=this.state.title;
                                  return (
                                    <div className="border-bottom p-2"><DiscussionBlockReply value={{"currpage": this.state.currentUrl, "data": threadItem, "type": "detail" }} /> </div>
                                  )
                                })
                              }
                              
                            </div>
                            </>
                          )
                        }

                      </div>
                      <div className="col-md-3 bg-light">
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handlePopOpen.bind(this,"modal_show_reply","modal_title_reply", GetText() ? "Beri Tanggapan" : "Give Response", "modal_content_reply", {threadId: this.state.id, threadTitle: this.state.title})} >
                          <FaPlus className="style-action-icons"  style={{size: "20px"}}  />
                          <span >{GetText() ? "Beri Tanggapan" : "Give Response "} </span>
                        </Button>
                        <Button variant="link" size="sm" type="button" className="btn-light text-decoration-none mt-4" onClick={this.handleOpenPage.bind(this, global.config.urlHost+"/"+this.state.arrPagePath[1]+"/"+this.state.arrPagePath[2])}>
                          <FaFile className="style-action-icons"  style={{size: "20px"}}  />
                          { 
                           GetText() ? "Lihat Semua Topik" : "All Topics"
                          } 
                        </Button>
                      </div>
                    </div>
                    
                   
                  </div>
                </Container>
              </section>
            : <Loading value={{id:'discussion-detail-area', divstyle:{}, componentstyle: {}}}/>
        }


          <Modal animation={false} show={this.state.modal_show_thread} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_thread","modal_title_thread","modal_content_thread")}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.modal_title_thread}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DiscussionForm value={this.state.modal_content_thread} />
            </Modal.Body>
          </Modal>

          <Modal animation={false} show={this.state.modal_show_reply} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_reply","modal_title_reply","modal_content_reply")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Beri Tanggapan" : "Give Response"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DiscussionFormReply value={this.state.modal_content_reply} />
            </Modal.Body>
          </Modal>
      </div>
    );
  }
}